<template>
  <div class="block" @click="goTodetail(project)">
    <div class="img-block dark">
      <router-link :to="{path: '/' + project.title}">
        <div class="img-content">
          <h2>{{project.main_title[lang]}}</h2>
          <p class="description">{{project.main_subtitle[lang]}}</p>
          <div class="btn">{{$locale.more[lang]}}</div>
        </div>
        <div class="gradient"></div>
        <imageBlur :url="project.media.thumb" :type="'img'" :alt="project.main_title[lang]"></imageBlur>
      </router-link>
    </div>
  </div>
</template>

<script>
import imageBlur from '../../../src/pages/components/imageBlur';
import { EventBus } from '../../../src/pages/components/eventBus.js';

export default {
    props: ['project'],
    components: {
      imageBlur: imageBlur
    },
    name: "imageBlock",
    data() {
      return {
        lang: 'en',
        link : '',
        loaded: false
      }
    },
    methods: {
      goTodetail(item) {
        this.$router.push({path:'/' + item.title});
      }
    },
    mounted: function() {
      EventBus.$on('lang', lang => {
        this.lang = lang;
      });
      EventBus.$emit('workHeight', document.getElementById("work").offsetHeight);
      this.lang = this.$cookie.get('pixel-deep.com');
    }
}

</script>

<style lang="scss" scoped>
    .img-block {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    // .media {
    //     width: 100%;
    //     height: 100%;
    //     z-index: 100;
    //     position: absolute;
    //     top: 50%;
    // }

    .fade-enter-active {
      transition: opacity 0.5s ease-in-out;
    }

    .fade-enter-to {
        opacity: 1;
        .img-block {
            padding-bottom: 100%;
        }
    }

    .fade-enter {
        opacity: 0;
        .img-block {
            padding-bottom: 0%;
        }
    }
</style>
